
export enum TraegerRegEntscheidung {
    Eingereicht = 'Eingereicht',
    Angenommen = 'Angenommen',
    Abgelehnt = 'Abgelehnt'
}

export namespace TraegerRegEntscheidung {
    export function keys(): any[] {
        const values = Object.values(TraegerRegEntscheidung) as string[];
        const results = [];
        for (let i = 0; i < values.length - 1; i++) {
            results.push({ id: i, name: values[i].replace('_', ' ') });
        }

        return results;
    }
}


// -------------------


export enum TraegerRegBearbeitunsStatus {
    Eingereicht = 'Eingereicht',
    Bearbeitung = 'Bearbeitung',
    Geschlossen = 'Geschlossen'
}

export namespace TraegerRegBearbeitunsStatus {
    export function keys(): any[] {
        const values = Object.values(TraegerRegBearbeitunsStatus) as string[];
        const results = [];
        for (let i = 0; i < values.length - 1; i++) {
            results.push({ id: i, name: values[i].replace('_', ' ') });
        }

        return results;
    }
}



// -------------------


export enum TraegerRegGrund {
    Stationaer = 'stationär (§ 34 SGB VIII)',
    Teilstationaer = 'teilstationaer (§ 32 SB VIII)',
    Eingliederungshilfe = 'Eingliederungshilfe',
    Wohnheime_Internate = 'Wohnheime / Internate'
}

export namespace TraegerRegGrund {
    export function keys(): any[] {
        const values = Object.values(TraegerRegGrund) as string[];
        const results = [];
        for (let i = 0; i < values.length - 1; i++) {
            results.push({ id: i, name: values[i].replace('_', ' ') });
        }

        return results;
    }
}
